import React from "react";
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Dots, Gradient1 } from "assets/vectors";
import { BigCta } from "components/big-cta";
import { Footer } from "components/footer";
import { NavBar } from "components/navbar";
import AboutBanner from "containers/about-banner";
import { MainContainer } from "containers/main-container";
import { Meta } from "seo/meta";
import { Card, CardsWrapper } from "styles/cards";
import {
   TextHeadingTwo,
   ParagraphText,
   Span,
   Underlined,
   TextHeadingThree,
} from "styles/typography";
import { IntroWrapper } from "styles/wrappers";

export default function AboutUs() {
   const { t } = useTranslation('common');
   return (
      <Meta
         title={t('seo-about-title')}
         description={t('seo-about-description')}
      >
         <MainContainer>
            <NavBar />
            <AboutBanner />

            <div style={{ margin: "5em 0", position: "relative" }}>
               <IntroWrapper>
                  <TextHeadingTwo mw="970" center style={{ fontSize: 36 }}>
                     {t('about-title', { Metricks: 'Metricks' })}{" "}
                     <Span color="#7211d4">{t('about-subtitle')}</Span>
                  </TextHeadingTwo>
               </IntroWrapper>

               <CardsWrapper col={2} gap={2.5}>
                  <Card style={{ boxShadow: "none", background: "transparent" }}>
                     <Underlined style={{ fontSize: 14, letterSpacing: 5 }} mw="140">
                        {t('about-card1-title')}
                     </Underlined>
                     <TextHeadingThree style={{ fontSize: 24 }}>
                        {t('about-card1-subtitle')}
                     </TextHeadingThree>
                     <br />
                     <ParagraphText>
                        {t('about-card1-description')}
                     </ParagraphText>
                     <br />
                     <br />
                     <br />
                     <Dots />
                  </Card>
                  <Card
                     style={{ boxShadow: "none", background: "transparent", position: "relative" }}
                  >
                     <Underlined
                        style={{ fontSize: 14, letterSpacing: 5 }}
                        color="#C349BF"
                        mw="300"
                     >
                        {t('about-card2-title')}
                     </Underlined>
                     <TextHeadingThree style={{ fontSize: 24 }}>
                        {t('about-card2-subtitle')}
                     </TextHeadingThree>
                     <br />
                     <Gradient1
                        style={{ position: "absolute", top: "-200px", bottom: 0, right: -"-200px" }}
                     />

                     <ParagraphText>
                        {t('about-card2-description')}
                     </ParagraphText>
                     <br />
                     <ParagraphText>
                        {t('about-card2-paragraph')}
                     </ParagraphText>
                  </Card>
               </CardsWrapper>
            </div>
            <BigCta />
         </MainContainer>
         <Footer />
      </Meta>
   );
}

export async function getStaticProps({ locale }) {
   return {
     props: {
       ...(await serverSideTranslations(locale, ['common', 'footer'])),
       // Will be passed to the page component as props
     },
   };
 }
